import { render } from "./EmergencyContactsList.vue?vue&type=template&id=f6841636&ts=true"
import script from "./EmergencyContactsList.ts?vue&type=script&lang=ts&external"
export * from "./EmergencyContactsList.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__